import React from 'react';
import { FolderIcon, ArrowRightBoldIcon } from '@components/icons/svg-icon.tsx';
import useMediaLibraryStore from '@store/media-library-store/media-library.store.ts';

const BreadcrumbNavigation: React.FC = () => {
  const { breadcrumb, goToBreadcrumb } = useMediaLibraryStore();

  if (breadcrumb.length === 0) return null;

  return (
    <nav className="inline-flex items-center rounded-[999px] bg-[var(--gray-11)] px-5 py-2 gap-3">
      {breadcrumb.map((item, index) => {
        const isLast = index === breadcrumb.length - 1;
        const isRoot = index === 0;

        return (
          <div
            key={item.id}
            className={`inline-flex items-center text-nowrap gap-2 cursor-pointer ${
              isLast ? 'text-[var(--primary)]' : 'text-[rgba(25,27,27,0.60)]'
            } ${isRoot ? 'font-bold' : ''}`}
            onClick={() => !isLast && goToBreadcrumb(item.id)}
          >
            <div className="flex items-center gap-2">
              <FolderIcon fill={isLast ? 'var(--primary)' : '#718EBF'} />
              <span className="font-medium">{item.title}</span>
            </div>

            {!isLast && (
              <span className="select-none">
                <ArrowRightBoldIcon
                  className="!w-[11px] !h-[11px]"
                  fill="rgba(25, 27, 27, 0.60)"
                />
              </span>
            )}
          </div>
        );
      })}
    </nav>
  );
};

export default BreadcrumbNavigation;
